import React from 'react';
import LastPublications from '../dashboard/components/LastPublications/LastPublications';
import Navbar from '../navbar/Navbar';
import { useSelector } from 'react-redux';
import Info from './SsoComponents/Info/Info';
import NextPublication from './SsoComponents/NextPublication/NextPublication';
import Networks from './SsoComponents/Networks/Networks';
import Help from './SsoComponents/Help/Help';
import { AddPublicationButton } from '../addPublicationButton/AddPublicationButton';
import iconShare from '../assets/IconShare.svg';
import iconMagicIA from '../assets/IconMagicIA.svg';
import iconHomeStorage from '../assets/IconHomeStorage.svg';
import iconMagic from '../assets/IconMagic.svg';
import Footer from '../footer/Footer';
import backgroundImageHandPhone from '../assets/sso/hand_phone.png';
import backgroundImagePhone from '../assets/newsfactory-phone-background.png';
import backgroundImageReviewsSection from '../assets/dashboard-sso-reviews-background.jpg';
import { selectUserAgency } from '../selectors/userSelectors';
import { capitalize } from '../utils/text';

function DashboardSso() {
    const agencyName = useSelector(selectUserAgency);

    return (
        <div className="overflow-x-hidden">
            <div className="inline-flex flex-1 relative w-full self-stretch overflow-x-hidden">
                <div>
                    <Navbar />
                </div>
                <div className="overflow-x-hidden w-full">
                    <div className="overflow-x-hidden w-full">
                        <div
                            className="flex flex-col px-9 pt-[40px] w-full justify-between"
                            style={{
                                backgroundImage: `url(${backgroundImagePhone}),
                                      linear-gradient(to right, white 0%, white 60%, transparent 100%)`,
                                backgroundSize: `100%`,
                            }}
                        >
                            <div className="self-stretch inline-flex justify-start items-center gap-10">
                                <div className="flex-1 flex justify-between items-center">
                                    <div className="flex-1 inline-flex flex-col justify-start items-start gap-0.5">
                                        <div className="self-stretch justify-center text-neutral-900 text-2xl font-semibold font-['Montserrat'] leading-loose">
                                            Bonjour {agencyName ? capitalize(agencyName) : ''}
                                        </div>
                                        <div className="self-stretch justify-center text-neutral-700 text-sm font-normal font-['Montserrat'] leading-tight">
                                            Avec News Factory, donnez vie à vos réseaux sociaux !
                                            <br />
                                            Créez vos publications avec l’IA, gérez leur diffusion,
                                            suivez vos derniers posts et répondez facilement aux
                                            avis de vos clients, le tout depuis une seule interface
                                            intuitive !
                                        </div>
                                    </div>
                                </div>
                                <AddPublicationButton></AddPublicationButton>
                            </div>

                            <div className="self-stretch inline-flex justify-start items-center gap-5 mt-6">
                                <div className="flex flex-col items-center gap-4 flex-[1_0_0] self-stretch rounded-[var(--Radius-2xl,16px)] [background:linear-gradient(180deg,rgba(255,255,255,0.50)_0%,#FFF_100%)] px-5 py-6 border-2 border-solid border-white">
                                    <div className="p-1.5 bg-lbi-secondary rounded-md inline-flex justify-start items-center gap-2.5">
                                        <div className="w-5 h-5 relative text-white">
                                            <img
                                                src={iconShare}
                                                alt="icon share"
                                                className="text-white fill-white"
                                            />
                                        </div>
                                    </div>
                                    <div className="self-stretch text-center justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                                        Gérer la diffusion des contenus <br /> Newsfactory
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 flex-[1_0_0] self-stretch rounded-[var(--Radius-2xl,16px)] [background:linear-gradient(180deg,rgba(255,255,255,0.50)_0%,#FFF_100%)] px-5 py-6 border-2 border-solid border-white">
                                    <div className="p-1.5 bg-lbi-secondary rounded-md inline-flex justify-start items-center gap-2.5">
                                        <div className="w-5 h-5 relative text-white">
                                            <img
                                                src={iconMagicIA}
                                                alt="icon magic IA"
                                                className="text-white fill-white"
                                            />
                                        </div>
                                    </div>
                                    <div className="self-stretch text-center justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                                        Créer vos publications
                                        <br />
                                        avec l’IA
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 flex-[1_0_0] self-stretch rounded-[var(--Radius-2xl,16px)] [background:linear-gradient(180deg,rgba(255,255,255,0.50)_0%,#FFF_100%)] px-5 py-6 border-2 border-solid border-white">
                                    <div className="p-1.5 bg-lbi-secondary rounded-md inline-flex justify-start items-center gap-2.5">
                                        <div className="w-5 h-5 relative">
                                            <img src={iconHomeStorage} alt="icon magic ia" />
                                        </div>
                                    </div>
                                    <div className="self-stretch text-center justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                                        Consulter tous vos
                                        <br />
                                        derniers posts
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 flex-[1_0_0] self-stretch rounded-[var(--Radius-2xl,16px)] [background:linear-gradient(180deg,rgba(255,255,255,0.50)_0%,#FFF_100%)] px-5 py-6 border-2 border-solid border-white">
                                    <div className="p-1.5 bg-lbi-secondary rounded-md inline-flex justify-start items-center gap-2.5">
                                        <div className="w-5 h-5 relative">
                                            <img src={iconMagic} alt="icon magic" />
                                        </div>
                                    </div>
                                    <div className="self-stretch text-center justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                                        Répondez aux avis
                                        <br />
                                        de vos clients avec l’IA
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col px-9 pb-10 w-full">
                            <div className="self-stretch h-px bg-neutral-200 my-6" />
                            <div className="flex self-auto flex-1 gap-5">
                                <div className="relative flex flex-1">
                                    <div className="flex flex-1 max-h-full">
                                        <LastPublications />
                                    </div>
                                </div>
                                <div className="flex flex-col flex-[2] justify-end gap-5">
                                    <div
                                        className="w-full h-[50%] xl rounded shadow-lg"
                                        style={{
                                            backgroundImage: `url(${backgroundImageReviewsSection})`,
                                            backgroundSize: `150% 170%`,
                                            backgroundRepeat: `no-repeat`,
                                            backgroundPosition: 'right 35% bottom 42%',
                                        }}
                                    >
                                        <Info />
                                    </div>
                                    <div className="flex w-full max-h-[60%] h-full gap-5">
                                        <div className="flex flex-col justify-between bg-white max-h-full w-full rounded-2xl gap-5 p-6 px-5 shadow-lg">
                                            <NextPublication />
                                        </div>
                                        <div className="flex flex-col w-full h-full gap-5">
                                            <div className="bg-white h-[50%] max-w-full rounded p-[1.25em_1.25em] shadow-lg">
                                                <Networks />
                                            </div>
                                            <div
                                                className="
                                                overflow-hidden
                                                h-[50%] max-w-full rounded-[var(--border-radius)] relative
                                                gap-5 px-5 py-6 text-white text-super-medium font-medium break-words
                                                bg-[rgba(98,170,71,1)] shadow-lg"
                                            >
                                                <img
                                                    src={backgroundImageHandPhone}
                                                    alt="img hand phone"
                                                    className="absolute right-2 -bottom-6 w-72"
                                                />
                                                <Help />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-8 myt-6 mb-10">
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardSso;
